// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"x1-z","button":"y1-z","disabled":"z1-z","creditCard":"A1-z","wrapper":"B1-z"};